module.exports = __webpack_public_path__ + "static/media/profile.7bd56c03.jpg";